import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Grid, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { gradients } from "../../config/theme";

const { useBreakpoint } = Grid;

// Routes where FAB should NOT appear
const EXCLUDED_PATHS = ["/dashboard", "/inbasket", "/profile", "/login"];

export const FloatingActionButton: React.FC = () => {
  const screens = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Only show on mobile
  if (screens.md) {
    return null;
  }

  // Only show on list pages (entity routes like /Lead, /Opportunity, etc.)
  const path = location.pathname;
  const isExcluded = EXCLUDED_PATHS.some(
    (p) => path === p || path.startsWith(p + "/"),
  );

  // Also exclude show/edit/create sub-routes (e.g., /Lead/123, /Lead/create)
  const pathSegments = path.split("/").filter(Boolean);
  const isListPage = pathSegments.length === 1 && !isExcluded;

  if (!isListPage) {
    return null;
  }

  const resource = pathSegments[0];

  return (
    <Tooltip title={t("actions.create")} placement="left">
      <Button
        data-testid="fab-create"
        type="primary"
        shape="circle"
        size="large"
        icon={<PlusOutlined />}
        onClick={() => navigate(`/${resource}/create`)}
        style={{
          position: "fixed",
          bottom: "calc(72px + env(safe-area-inset-bottom, 0px))",
          right: 16,
          width: 56,
          height: 56,
          fontSize: 24,
          zIndex: 999,
          background: gradients.primary,
          border: "none",
          boxShadow: "0 4px 16px rgba(99, 102, 241, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </Tooltip>
  );
};
